module.exports = __webpack_public_path__ + "static/img/exhibit-3.f4fb15f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/exhibit-3.jpg
// module id = 0+rd
// module chunks = 52